import { getApiUrlRoot } from 'utils/httpClient';
import { getProfile } from 'services/auth.service';
import { getPortalScope } from 'utils/portalScope';

export const createSseParser = (onEvent) => {
  let buffer = '';
  return (chunk) => {
    buffer += chunk;
    let boundary;
    while ((boundary = /\r?\n\r?\n/.exec(buffer))) {
      const block = buffer.slice(0, boundary.index);
      buffer = buffer.slice(boundary.index + boundary[0].length);
      let event = 'message';
      const data = [];
      block.split(/\r?\n/).forEach(line => {
        if (line.startsWith('event:')) event = line.slice(6).trim();
        if (line.startsWith('data:')) data.push(line.slice(5).replace(/^ /, ''));
      });
      if (!data.length) continue;
      try { onEvent(event, JSON.parse(data.join('\n'))); } catch (_) { /* Ignore incomplete or invalid events. */ }
    }
    if (buffer.length > 1024 * 1024) buffer = '';
  };
};

export const startRealtimeStream = (path, { onUpdate, onStatus = () => {} } = {}) => {
  let active = true;
  let controller;
  let retryTimer;
  let attempts = 0;
  const connect = async () => {
    controller = new AbortController();
    const headers = { Accept: 'text/event-stream' };
    const scope = getPortalScope();
    ['company', 'business', 'store'].forEach(key => {
      if (scope[`${key}_id`]) headers[`X-${key[0].toUpperCase()}${key.slice(1)}-Id`] = scope[`${key}_id`];
    });
    const url = `${getApiUrlRoot().replace(/\/$/, '')}/${path.replace(/^\//, '')}`;
    const options = { credentials: 'include', cache: 'no-store', headers, signal: controller.signal };
    try {
      onStatus('connecting');
      let response = await fetch(url, options);
      if (response.status === 401) {
        await getProfile();
        if (!active) return;
        response = await fetch(url, options);
      }
      if (!active) return;
      if ([401, 403, 404].includes(response.status)) {
        onStatus('unavailable');
        return;
      }
      if (!response.ok || !response.body || !response.headers.get('content-type')?.includes('text/event-stream')) {
        throw new Error('Stream unavailable');
      }
      attempts = 0;
      onStatus('connected');
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      const parse = createSseParser((event, data) => {
        if (active && event === 'update') onUpdate?.(data);
      });
      while (active) {
        const result = await reader.read();
        if (result.done) break;
        parse(decoder.decode(result.value, { stream: true }));
      }
    } catch (_) {
      if (!active) return;
    }
    if (active) {
      onStatus('reconnecting');
      retryTimer = window.setTimeout(connect, Math.min(30000, 1000 * (2 ** Math.min(attempts++, 5))));
    }
  };
  connect();
  return () => {
    active = false;
    window.clearTimeout(retryTimer);
    controller?.abort();
  };
};
